import { render, staticRenderFns } from "./BudgetResource.vue?vue&type=template&id=63d78ac9"
import script from "./BudgetResource.vue?vue&type=script&lang=js"
export * from "./BudgetResource.vue?vue&type=script&lang=js"
import style0 from "./BudgetResource.vue?vue&type=style&index=0&id=63d78ac9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports